import { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Link, useParams } from "react-router-dom"
import { bindActionCreators } from "redux"
import { callUserViewGet, callUserPost, callUserPut, callUserClearView } from "../../actions/users"

let UserEdit = ({ setPageAttr, methods: { callUserPost, callUserViewGet, callUserPut, callUserClearView }, view }) => {
    const params = useParams()
    const [id] = useState(!params.id ? '' : params.id)
    const [profile, setProfile] = useState('')
    const [name, setName] = useState('')
    const [username, setUsername] = useState('')
    const [pass, setPass] = useState('')
    const [passConfirm, setPassConfirm] = useState('')

    useEffect(() => {
        callUserClearView()
        let tabs
        if (!id) {
            tabs = [
                {
                    active: false,
                    to: '/users',
                    label: 'Informações'
                },
                {
                    active: true,
                    to: '/users/add',
                    label: 'Adicionar'
                }
            ]
        } else {
            callUserViewGet(id)
            tabs = [
                {
                    active: false,
                    to: '/users',
                    label: 'Informações'
                },
                {
                    active: true,
                    to: '/users/edit/' + id,
                    label: 'Editar'
                },
                {
                    active: false,
                    to: '/users/companies/' + id,
                    label: 'Empresas'
                },
                {
                    active: false,
                    to: '/users/regions/' + id,
                    label: 'Regiões'
                }
            ]
        }

        setPageAttr({
            title: 'Usuário - ' + (!id ? 'Novo' : 'Editar'),
            caption: 'Preencha os campos para inserir as informações',
            btns: [],
            tabs: tabs
        })
    }, [setPageAttr, id, callUserViewGet, callUserClearView])

    useEffect(() => {
        setProfile(view.profile)
        setName(view.name)
        setUsername(view.username)
    }, [view])

    const finishedSubmit = () => {
        setProfile('')
        setName('')
        setUsername('')
        setPass('')
        setPassConfirm('')
        window.navigate('/users')
    }

    const submit = (e) => {
        e.preventDefault()

        let data = {
            profile: profile,
            name: name,
            username: username,
            pass: pass,
            passConfirm: passConfirm
        }

        if (!id) {
            callUserPost(data, () => finishedSubmit())
        } else {
            callUserPut(id, data, () => finishedSubmit())
        }
    }

    return (
        <form onSubmit={submit}>
            <div className="form-row">
                <div className="col-md-12">
                    <div className="form-row">
                        <div className="col-md-4 form-group">
                            <label className="required">Perfil:</label>
                            <select className="form-control" value={profile} onChange={e => setProfile(e.target.value)}>
                                <option value=''>Selecione</option>
                                <option value='admin'>Administrador</option>
                                <option value='customer'>Cliente</option>
                                <option value='technician'>Técnico</option>
                                <option value='monitoring'>Monitoramento</option>
                            </select>
                        </div>
                        <div className="col-md-4 form-group">
                            <label className="required">Nome:</label>
                            <input type="text" className="form-control" value={name} onChange={e => setName(e.target.value)} />
                        </div>
                        <div className="col-md-4 form-group">
                            <label className="required">Nome de Usuário:</label>
                            <input type="text" className="form-control" value={username} onChange={e => setUsername(e.target.value)} />
                        </div>
                        <div className="col-md-4 form-group">
                            <label className="required">Senha:</label>
                            <input type="password" className="form-control" value={pass} onChange={e => setPass(e.target.value)} />
                        </div>
                        <div className="col-md-4 form-group">
                            <label className="required">Confirmar Senha:</label>
                            <input type="password" className="form-control" value={passConfirm} onChange={e => setPassConfirm(e.target.value)} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="clearfix text-left mt-3">
                <button className="btn btn-primary" type="submit"><i className="mr-1 fas fa-save fa-white"></i>Salvar</button>
                <Link to={'/users'} className="btn btn-secondary ml-3"><i className="fas fa-arrow-left mr-1"></i>Voltar</Link>
            </div>
        </form>
    )
}

const mapStateToProps = ({ register: { users: { view } } }) => ({
    view: view,
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callUserViewGet,
            callUserPost,
            callUserClearView,
            callUserPut
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(UserEdit)